import tarifaMixin from "./tarifaMixin";

export default {
  data: () => ({
    mixData: 10,
  }),
  created() { },
  methods: {
    buildRVAData(data) {
      let dataRVA = {
        Cliente: {
          Nombre: data.Cliente.name,
          Correo: data.Cliente.email,
          Telefono: data.Cliente.phone,
          IdCliente: data.Cliente.isClient ? data.Cliente.IdCliente : null,
        },
        Bahia: data.Bahia,
        Estatus: "Confirmed",
        RF: {
          FI: data.FechaInicial, // Fecha Inicio
        },
        Privado: data.Privado,
        Totales: {
          USD: parseFloat(data.Total.total),
          MXN: parseFloat(data.Total.totalPesos),
        },
        Creador: data.Creador,
        Prepagado: data.Prepagado,
        Notas: data.Notas,
        Departamento: data.Departamento,
        Tags: data.Tags,
        Mayorista: data.Mayorista,
        Transportacion: data.Transportacion,
        Cuentas: {},
      };

      if (data.FechaFinal) {
        dataRVA.RF.FT = data.FechaFinal;
      }

      //armado de la data de cuentas

      data.Players.forEach((player, index) => {
        let catalogo = [];

        //producto Tarifa
        if (player.useRondaCupon) {
          catalogo.push({
            Id: player.dataCupones[0].Codigo,
            Tip: "Serie",
            Orn: data.Departamento,
            Nombre: player.dataCupones[0].Nombre,
            Pco: player.dataCupones[0].Precio,
            Cnt: 1,
            Mnd: player.dataCupones[0].Moneda,
            ExtraParams: {
              TarifaData: {
                CCI: player.dataCupones[0].CCI,
              },
            },
          });
        } else {
          /*if (data.Tipo == "TopTracer") {
            if (data.TTProduct) {
              catalogo.push({
                Id: player.TarifaSelected.TarifaId,
                Orn: data.Departamento,
                Tip: "Reserva",
                Cnt: 1,
                Pco: parseFloat(data.Total.total),
                Nombre: "Top Tracer web ",
                Mnd: "USD",
                ExtraParams: {
                  TimesData: data.TimesData,
                  TTEData: data.TTEData,
                },
                Departamento: data.Departamento,
              });
            } else {
              catalogo.push({
                Id: player.TarifaSelected.TarifaId,
                Orn: data.Departamento,
                Tip: "Reserva",
                Cnt: 1,
                Pco: parseFloat(data.Total.total),
                Nombre: "Top Tracer " + player.TarifaSelected.Nombre,
                Mnd: "USD",
                ExtraParams: {
                  Tarifa: player.TarifaSelected.Tarifa.data,
                  TimesData: data.TimesData,
                  TTEData: data.TTEData,
                },
                Departamento: data.Departamento,
              });
            }
          } else {*/
          let ExtraP = {};
          if (data.Tipo != "Golf") {
            let dataTar = player.TarifaSelected;
            player.TarifaSelected.Horario = { id: dataTar.IdHorario };
            player.TarifaSelected.Precio = parseFloat(dataTar.PrecioNumber);
            player.TarifaSelected.Moneda = dataTar.moneda;

            ExtraP = {
              TarifaData: {
                Mod: data.Modalidad.id,
                Hor: dataTar.IdHorario,
                Pcc: 0,
                Pcv: player.TarifaSelected.Precio,
                Sub: "Top Tracer WEB",
                SubN: "Top Tracer WEB",
                Fam: "Top Tracer",
                EC: player.useCupon,
                Tem: player.TarifaSelected.Tarifa.Temporada,
                Tar: dataTar.IdTarifario,
                Tur: false,
                Clr: null,
              },
            };
          } else {
            ExtraP = {
              TarifaData: {
                Mod: data.Modalidad.id,
                Hor: player.TarifaSelected.Horario.id,
                Pcc: player.TarifaSelected.PrecioCon
                  ? player.TarifaSelected.PrecioCon
                  : 0,
                Pcv: player.TarifaSelected.Precio,
                Sub: player.TarifaSelected.Tarifa?.cateTarifa?.id,
                SubN: player.TarifaSelected.Tarifa?.cateTarifa?.nombre,
                Fam: data.Familia,
                EC: player.useCupon,
                Tem: player.TarifaSelected.Tarifa.Temporada,
                Tar: player.TarifaSelected.Tarifa.Tarifario,
                Seg: player?.TarifaSelected?.Seg || null,
                SegN: player?.TarifaSelected?.SegN || null,
                Mer: player?.TarifaSelected?.Mer || null,
                MerN: player?.TarifaSelected?.MerN || null,
                Clr: player?.TarifaSelected?.Color || null,
              },
            };
          }
          catalogo.push({
            Id: player.TarifaSelected.TarifaId,
            Tip: "Reserva", //data.Addons.roundGolf.Tipo,
            Orn: data.Departamento,
            Nombre:
              player.TarifaSelected.Nombre +
              "/" +
              player.TarifaSelected.horarioNombre +
              " - " +
              data.Modalidad.nombre,
            Pco: player.TarifaSelected.Precio,
            Cnt: 1,
            Mnd: player.TarifaSelected.Moneda,
            ExtraParams: ExtraP,
          });
          /*}*/
        }

        //golfClub
        if (player.golfClub) {
          catalogo.push({
            Id: data.Addons.golfClub.id,
            Tip: data.Addons.golfClub.Tipo,
            Nombre: data.Addons.golfClub.Nombre,
            Pco: data.Addons.golfClub.Precio,
            Orn: data.Departamento,
            Cnt: 1,
            Mnd: data.Addons.golfClub.Moneda,
            ExtraParams: {
              GCExtraData: {
                Gender: player.genero,
                Shaft: player.shaft,
                Side: player.side,
              },
            },
          });
        }
        dataRVA.Cuentas[index] = {
          Nombre: player.name,
          Correo: player.email,
          Telefono: player.phone,
          IdCliente: player.isClient ? player.IdCliente : null,
          Catalogo: catalogo,
        };
      });

      let Acompañantes = [];
      if (data.CartRiders.length > 0) {
        data.CartRiders.forEach((element) => {
          element.Pco.C = Number(element.Pco.C);
          Acompañantes.push(element);
        });
      }

      dataRVA.Acompañantes = Acompañantes.length != 0 ? Acompañantes : null;
      //Cuenta extraData
      /*let ExtraCatalogo = [];
      if (data.CartRiders.length > 0) {
        let extra_rider = [];
        this.cartRiders.forEach((element) => {
          extra_rider.push(element.name);
        });
        ExtraCatalogo.push({
          Id: data.Addons.cartRider.id,
          Tip: data.Addons.cartRider.Tipo,
          Nombre: data.Addons.cartRider.Nombre,
          Orn: data.Departamento,
          Pco: data.Addons.cartRider.Precio,
          Cnt: data.CartRiders.length,
          Mnd: data.Addons.cartRider.Moneda,
          ExtraParams: {
            ERExtraData: extra_rider.map((EXplayer) => {
              return { N: EXplayer, E: 'R' };
            })
          }
        });
      }



      dataRVA.Cuentas['Extra'] = {
        Catalogo: ExtraCatalogo
      }*/

      return dataRVA;
    },
  },
};
